import React, { useEffect, useState } from 'react';
import ThumbsUp from './ThumbsUp.svg';
import styles from './ThumbsUpButton.module.css';
import { thumbsUp } from '../../redux/message/actions.js';
import { useDispatch, useSelector } from 'react-redux';

function ThumbsUpButton({ user_id, message_id }) {
  const dispatch = useDispatch();
  const messages = useSelector(state => state.message.messages);
  const [isThumbsUp, setIsThumbsUp] = useState(false);

  useEffect(() => {
    const message = messages.find(msg => msg.message_id === message_id);
    if (message) {
      setIsThumbsUp(Boolean(message.thumbs_up));
    }
  }, [messages, message_id]);

  const handleClick = async ()  => {
    await dispatch(thumbsUp(user_id, message_id));
    setIsThumbsUp(!isThumbsUp);
  };

  return (
    <img 
      className={`${styles.image} ${isThumbsUp ? styles.active : ''}`}
      src={ThumbsUp} 
      alt="ThumbsUp" 
      onClick={handleClick} 
    />
  );
}

export default ThumbsUpButton;